"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudentIdTextarea = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * StudentIdTextarea - Textarea for UUID student IDs
 *
 * Replaces StudentMultiSelect for SNAP page.
 * One ID per line, real-time validation, count display.
 */
const react_1 = require("react");
const UUID_PATTERN = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
const StudentIdTextarea = ({ value, onChange, disabled = false, error, label = 'Student IDs (one UUID per line)', }) => {
    const parsedIds = (0, react_1.useMemo)(() => {
        return value
            .split('\n')
            .map((line) => line.trim())
            .filter((line) => line.length > 0);
    }, [value]);
    const validCount = (0, react_1.useMemo)(() => {
        return parsedIds.filter((id) => UUID_PATTERN.test(id)).length;
    }, [parsedIds]);
    const invalidCount = parsedIds.length - validCount;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "student-id-textarea", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "student-ids-input", children: label }), (0, jsx_runtime_1.jsx)("textarea", { id: "student-ids-input", value: value, onChange: (e) => onChange(e.target.value), rows: 8, disabled: disabled, style: {
                    width: '100%',
                    fontFamily: 'monospace',
                    marginTop: '0.5rem',
                    borderColor: error ? 'red' : undefined,
                }, placeholder: "Enter student UUIDs, one per line...", "aria-invalid": !!error, "aria-describedby": error ? 'student-ids-error' : undefined }), (0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', gap: '1rem', fontSize: '0.875rem', marginTop: '0.25rem' }, children: [(0, jsx_runtime_1.jsxs)("span", { style: { color: '#666' }, children: [parsedIds.length, " ID(s) entered"] }), parsedIds.length > 0 && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("span", { style: { color: 'green' }, children: [validCount, " valid"] }), invalidCount > 0 && ((0, jsx_runtime_1.jsxs)("span", { style: { color: 'red' }, children: [invalidCount, " invalid"] }))] }))] }), error && ((0, jsx_runtime_1.jsx)("p", { id: "student-ids-error", style: { color: 'red', fontSize: '0.875rem', marginTop: '0.25rem' }, children: error }))] }));
};
exports.StudentIdTextarea = StudentIdTextarea;
exports.default = exports.StudentIdTextarea;
